import Glide from '@glidejs/glide';

import '@glidejs/glide/dist/css/glide.core.min.css';

if (document.querySelector('.glide-voitures')) {
	var glideVoitures = new Glide('.glide-voitures', {
		type: 'slider',
		gap: 15,
		perView: 5.5,
		bound: true,
		rewind: true,
		startAt: 0,
		breakpoints: {
			1920: {
				perView: 4.5
			},
			1024: {
				perView: 3.5
			},
			768: {
				perView: 2.5
			},
			568: {
				perView: 1.25
			}
		}
	})
	glideVoitures.mount()
}

if (document.querySelector('.dernieres-voitures')) {
	var dernieresVoitures = new Glide('.dernieres-voitures', {
		type: 'slider',
		gap: 15,
		perView: 4,
		bound: true,
		rewind: false,
		startAt: 0,
		breakpoints: {
			1024: {
				perView: 3
			},
			768: {
				perView: 2
			},
			568: {
				perView: 1
			}
		}
	})
	dernieresVoitures.mount()
}

if (document.querySelector('.glide-actualites')) {
	var glideActualites = new Glide('.glide-actualites', {
		type: 'slider',
		gap: 30,
		perView: 2.5,
		bound: true,
		rewind: true,
		startAt: 0,
		breakpoints: {
			1440: {
				perView: 1.5
			},
			568: {
				perView: 1
			}
		}
	})
	glideActualites.mount()
}

if (document.querySelector('.dernieres-actualites')) {
	var dernieresActualites = new Glide('.dernieres-actualites', {
		type: 'slider',
		gap: 30,
		perView: 3,
		bound: true,
		rewind: true,
		startAt: 0,
		breakpoints: {
			1023: {
				perView: 2
			},
			568: {
				perView: 1
			}
		}
	})
	dernieresActualites.mount()
}

if (document.querySelector('.glide-gallery')) {
	Array.from(document.querySelectorAll('.glide-gallery')).forEach((gallery) => {
        var glideGallery = new Glide(gallery, {
            type: 'slider',
            gap: 15,
            perView: 5,
            bound: true,
            rewind: true,
            startAt: 0,
            breakpoints: {
                1440: {
                    perView: 4
                },
                1024: {
                    perView: 3.25
                },
                768: {
                    perView: 2.25
                },
                568: {
                    perView: 1.25
                }
            }
        })
        glideGallery.mount();
    });
}
